import { formatteerEuro, type Cent } from '@qc/core';

export interface BedragProps {
  centen: Cent;
  metSymbool?: boolean;
  className?: string;
}

/**
 * Toont een bedrag. De UI rekent zelf niets uit en rondt niets af (regel 1);
 * hij vraagt packages/core om de tekst.
 */
export function Bedrag({ centen, metSymbool = true, className = '' }: BedragProps) {
  return (
    <span className={`tabular-nums ${className}`}>{formatteerEuro(centen, { metSymbool })}</span>
  );
}
